<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { AccordionTriggerProps } from 'reka-ui';
  import { AccordionHeader, AccordionTrigger } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';
  import ArrowDown from '@/shared/assets/icons/ArrowDown.svg';
  import { cn } from '@/shared/lib/utils';
  import { IconImage } from '@/shared/ui';

  const props = defineProps<
    AccordionTriggerProps & {
      class?: HTMLAttributes['class'];
      icon: string | object;
    }
  >();

  const delegatedProps = reactiveOmit(props, 'class', 'icon');
</script>

<template>
  <AccordionHeader class="flex">
    <AccordionTrigger
      data-slot="accordion-trigger"
      v-bind="delegatedProps"
      :class="
        cn(
          'permissions-accordion-trigger flex h-[42px] w-full items-center justify-between gap-2 border-b border-gray-03 p-2 outline-none disabled:cursor-not-allowed disabled:border-gray-02',
          props.class
        )
      "
    >
      <span class="flex items-center gap-2">
        <span
          class="flex h-6.5 w-6.5 flex-shrink-0 items-center justify-center rounded-sm bg-[var(--theme-secondary)]"
        >
          <component :is="icon" class="text-[var(--theme-on-secondary)]" />
        </span>
        <span class="text-sm font-medium text-gray-07">
          <slot />
        </span>
      </span>

      <IconImage
        :src="ArrowDown"
        alt="Expandir ou recolher seção"
        class="permissions-accordion-chevron pointer-events-none shrink-0 text-gray-03 transition-transform duration-200"
      />
    </AccordionTrigger>
  </AccordionHeader>
</template>

<style scoped>
  .permissions-accordion-trigger[data-state='open'] .permissions-accordion-chevron {
    transform: rotate(180deg);
  }

  .permissions-accordion-trigger:disabled {
    opacity: 0.6;
  }
</style>
